import React, {Component} from 'react';
import Slider from "react-slick";
import './ThreeSlider.css';

/*
    Passed props:
    1) elements: contains list of HTML nodes
    2) pcdots: Showing dots on PC or not
    3) mobiledots: Showing dots on mobile or not
    4) (Optional) top: The top offset, default 45
    5) (Optional) swipe: Can configure swipe or not, default false
 */

let leftArrowImg = require('./../../images/slick-slider/slick-slider-left.jpg');
let rightArrowImg = require('./../../images/slick-slider/slick-slider-right.jpg');
let defaultTop = 45;
let defaultSwipe = false;
let defaultPCDots = false;
let defaultMobileDots = false;

let sliderSettings = {
    dots: defaultPCDots,
    infinite: false,
    swipe: defaultSwipe,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                dots: defaultMobileDots,
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 600,
            settings: {
                dots: defaultMobileDots,
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                dots: defaultMobileDots,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

export default class ThreeSlider extends Component{
    constructor(props) {
        super(props);
    }

    render(){
        sliderSettings.dots = this.props.pcdots;
        sliderSettings.responsive[0].settings.dots = this.props.mobiledots;
        sliderSettings.responsive[1].settings.dots = this.props.mobiledots;
        sliderSettings.responsive[2].settings.dots = this.props.mobiledots;

        if(this.props.top !== undefined){
            defaultTop = this.props.top;
        }
        else{
            defaultTop = 45;
        }

        if(this.props.swipe !== undefined){
            defaultSwipe = this.props.swipe;
        }

        if(this.props.pcMax !== undefined){
            sliderSettings.slidesToShow = this.props.pcMax;
            sliderSettings.slidesToScroll = this.props.pcMax;
        }
        else{
            sliderSettings.slidesToShow = 4;
            sliderSettings.slidesToScroll = 4;
        }

        if(this.props.tabletMax !== undefined){
            sliderSettings.responsive[0].settings.slidesToShow = this.props.tabletMax;
            sliderSettings.responsive[0].settings.slidesToScroll = this.props.tabletMax;
        }
        else{
            sliderSettings.responsive[0].settings.slidesToShow = 3;
            sliderSettings.responsive[0].settings.slidesToScroll = 3;
        }
        if(this.props.forceAllMax !== undefined){
            sliderSettings.responsive[0].settings.slidesToShow = this.props.forceAllMax;
            sliderSettings.responsive[0].settings.slidesToScroll = this.props.forceAllMax;
            sliderSettings.responsive[1].settings.slidesToShow = this.props.forceAllMax;
            sliderSettings.responsive[1].settings.slidesToScroll = this.props.forceAllMax;
            sliderSettings.responsive[2].settings.slidesToShow = this.props.forceAllMax;
            sliderSettings.responsive[2].settings.slidesToScroll = this.props.forceAllMax;
        }
        else{
            sliderSettings.responsive[0].settings.slidesToShow = 3;
            sliderSettings.responsive[0].settings.slidesToScroll = 3;
            sliderSettings.responsive[1].settings.slidesToShow = 2;
            sliderSettings.responsive[1].settings.slidesToScroll = 2;
            sliderSettings.responsive[2].settings.slidesToShow = 1;
            sliderSettings.responsive[2].settings.slidesToScroll = 1;
        }


        return(
            <Slider {...sliderSettings}>
                {this.props.elements}
            </Slider>
        );
    }
}

function CustomPrevArrow(props) {
    const { className, style, onClick } = props;
    const displayStyle = props.currentSlide === 0 ? "none" : "block";

    let top = {...defaultTop};

    return (
        <div
            className={className}
            style={{ ...style, display: displayStyle, top: top, left: "0px", zIndex: "1000" }}
            onClick={onClick}>
            <img src={leftArrowImg} className='custom-slide-arrow' />
        </div>
    );
}

function CustomNextArrow(props) {
    const { className, style, onClick } = props;
    const windowWidth = window.innerWidth;

    let slideToScroll = sliderSettings.slidesToScroll;
    if(windowWidth > 1024){
        slideToScroll = sliderSettings.slidesToScroll;
    }
    else if(windowWidth > 600 && windowWidth <= 1024){
        slideToScroll = sliderSettings.responsive[0].settings.slidesToScroll;
    }
    else if(windowWidth > 480 && windowWidth <= 600){
        slideToScroll = sliderSettings.responsive[1].settings.slidesToScroll;
    }
    else{
        slideToScroll = sliderSettings.responsive[2].settings.slidesToScroll;
    }

    let top = {...defaultTop};

    const displayStyle = (props.currentSlide + slideToScroll >= props.slideCount) ? "none" : "block";

    return (
        <div
            className={className}
            style={{ ...style, display: displayStyle, top: top, right: "20px", zIndex: "1000"}}
            onClick={onClick}>
            <img src={rightArrowImg} className='custom-slide-arrow' />
        </div>
    );
}